module.exports = __webpack_public_path__ + "static/img/info-bg02.ed111a6f.png";